import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// 清除缓存的函数
const clearAllStorage = () => {
    try {
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
        sessionStorage.clear()
        console.log('Vuex: 所有缓存已清除')
    } catch (error) {
        console.error('Vuex: 清除缓存时出错:', error)
    }
}

export default new Vuex.Store({
    state: {
        userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
        token: localStorage.getItem('token') || '',
        // 新增：认证警告状态
        authWarning: {
            hasWarning: false,
            message: '',
            type: ''
        }
    },
    mutations: {
        // 保存用户信息
        SET_USER_INFO(state, userInfo) {
            state.userInfo = userInfo
            localStorage.setItem('userInfo', JSON.stringify(userInfo))
        },
        // 保存token
        SET_TOKEN(state, token) {
            state.token = token
            localStorage.setItem('token', token)
        },
        // 清除登录状态
        LOGOUT(state) {
            state.userInfo = {}
            state.token = ''
            clearAllStorage()
        },
        // 新增：清除所有状态
        CLEAR_ALL(state) {
            state.userInfo = {}
            state.token = ''
            clearAllStorage()
        },
        // 新增：设置认证警告
        SET_AUTH_WARNING(state, warning) {
            state.authWarning = {
                hasWarning: warning.hasWarning,
                message: warning.message || '',
                type: warning.type || ''
            }
        },
        // 新增：清除认证警告
        CLEAR_AUTH_WARNING(state) {
            state.authWarning = {
                hasWarning: false,
                message: '',
                type: ''
            }
        }
    },
    actions: {
        // 登录后保存状态
        login({ commit }, { userInfo, token }) {
            commit('SET_USER_INFO', userInfo)
            commit('SET_TOKEN', token)
            commit('CLEAR_AUTH_WARNING') // 登录时清除警告
        },
        // 退出登录
        logout({ commit }) {
            commit('LOGOUT')
            commit('CLEAR_AUTH_WARNING')
        },
        // 新增：清除所有状态
        clearAll({ commit }) {
            commit('CLEAR_ALL')
        },
        // 新增：显示认证警告
        showAuthWarning({ commit }, { message, type }) {
            commit('SET_AUTH_WARNING', {
                hasWarning: true,
                message,
                type
            })
        },
        // 新增：清除认证警告
        clearAuthWarning({ commit }) {
            commit('CLEAR_AUTH_WARNING')
        }
    },
    getters: {
        isLogin: state => !!state.token,
        userRole: state => state.userInfo.role,
        // 新增：认证警告状态
        hasAuthWarning: state => state.authWarning.hasWarning,
        authWarningMessage: state => state.authWarning.message
    }
})
